import { createSlice } from '@reduxjs/toolkit';

export const HomeSlice = createSlice({
  name: 'home',
  initialState: {
    rowsPerPage: {},
    userInfo: {},
    notifications: [],
    selectedBusinessUnits: null,
    allBusinessUnits: [],
    actualWorkshopsList: [],
  },
  reducers: {
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setSelectedBusinessUnits: (state, action) => {
      state.selectedBusinessUnits = action.payload;
    },
    setAllBusinessUnits: (state, action) => {
      state.allBusinessUnits = action.payload;
    },
    setActualWorkshopsList: (state, action) => {
      state.actualWorkshopsList = action.payload.data;
    },
  },
});
export const {
  setRowsPerPage,
  setUserInfo,
  setNotifications,
  setSelectedBusinessUnits,
  setAllBusinessUnits,
  setActualWorkshopsList,
} = HomeSlice.actions;

export const rowsPerPageState = (state) => state.home.rowsPerPage;
export const userInfoState = (state) => state.home.userInfo;
export const notificationsState = (state) => state.home.notifications;
export const selectedBusinessUnitsState = (state) =>
  state.home.selectedBusinessUnits;
export const allBusinessUnitsState = (state) => state.home.allBusinessUnits;
export const actualWorkshopsListState = (state) =>
  state.home.actualWorkshopsList;
export default HomeSlice.reducer;
